export const API_URL = import.meta.env.VITE_API_URL || "http://127.0.0.1:8000/api";
export const APP_NAME = import.meta.env.VITE_APP_NAME || "HITCLICKS Academy";
export const APP_URL = import.meta.env.VITE_APP_URL || "https://academy.hitclicks.com";
